(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-products-faqs"] && !window.DesignMode) return;
  try {
    
    // Accordion Functionality
// Handles toggle behavior for custom accordion component

document.addEventListener('DOMContentLoaded', function() {
  // Wait for DOM to fully load
  const accordionTriggers = document.querySelectorAll('.accordion-trigger');
  
  accordionTriggers.forEach(trigger => {
    // Add click event listener to each accordion trigger
    trigger.addEventListener('click', function(event) {
      const content = this.nextElementSibling;
      const isOpen = content.classList.contains('active');
      
      // Toggle content visibility
      if (isOpen) {
        content.classList.remove('active');
        this.querySelector('.accordion-icon').textContent = '+';
      } else {
        content.classList.add('active');
        this.querySelector('.accordion-icon').textContent = '-';
      }
    });
    
    // Add right-click context menu support
    trigger.addEventListener('contextmenu', function(event) {
      event.preventDefault();
      
      const contextMenu = document.getElementById('custom-context-menu');
      if (contextMenu) {
        contextMenu.style.display = 'block';
        contextMenu.style.left = `${event.pageX}px`;
        contextMenu.style.top = `${event.pageY}px`;
      }
    });
  });
});
  
  } catch(e) { console.error(e); }
})();
})();
